var Class = function Class() {};

export default Class;